import { render, staticRenderFns } from "./SalesAmountMismatch.vue?vue&type=template&id=714af8f4&scoped=true&"
import script from "./SalesAmountMismatch.vue?vue&type=script&lang=js&"
export * from "./SalesAmountMismatch.vue?vue&type=script&lang=js&"
import style0 from "./SalesAmountMismatch.vue?vue&type=style&index=0&id=714af8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714af8f4",
  null
  
)

export default component.exports